$(document).ready(function () {
  const debug = true;
  const log = (() => {
    const colors = {
      info: "#3498db",
      success: "#2ecc71",
      error: "#e74c3c",
    };

    const logFn = (type, ...args) => {
      if (debug) {
        console.log(
          `%cNP-LPFocuspatchPet`,
          `background: ${colors[type]}; color: white; padding: 2px 5px; border-radius: 3px;`,
          ...args
        );
      }
    };

    return {
      info: (...args) => logFn("info", ...args),
      success: (...args) => logFn("success", ...args),
      error: (...args) => logFn("error", ...args),
    };
  })();

  function initScrolling() {
    $(".lp-fpp--learn-more-btn").click(function () {
      $(".lp-fpp--scroll-to-learn").fadeIn("slow");

      const sectionHeight = $(
        ".lp-fpp--why-kids-love-np-section"
      ).outerHeight();
      const sectionOffsetTop = $(".lp-fpp--why-kids-love-np-section").offset()
        .top;

      $(window).scroll(function () {
        let scrollTopj = $(window).scrollTop();
        let scrollPoint = sectionOffsetTop + sectionHeight;
        if (scrollTopj >= scrollPoint) {
          $(".lp-fpp--scroll-to-learn").fadeOut("fast");
        }
      });
    });

    log.success("Scrolling initialized");
  }

  function initTooltips() {
    $(".bundle-save-tooltip-box").on("click", function () {
      $(".bundle-save-tooltip-box").tooltip("show");
      setTimeout(() => {
        log.info("Updating tooltip");
        $(".bundle-save-tooltip-box").tooltip("update");
      }, 50);
    });
    $(".bundle-save-tooltip-box").on("show.bs.tooltip", function () {
      $(this).tooltip("update");
      $("#blur").fadeIn();
      log.info("Tooltip shown");
    });
    $(".bundle-save-tooltip-box").on("hide.bs.tooltip", function () {
      $("#blur").fadeOut();
      log.info("Tooltip hidden");
    });

    $("#blur").on("click", function (e) {
      $(".bundle-save-tooltip-box").tooltip("hide");
    });

    $('[data-toggle="tooltip"]').tooltip({
      container: ".form-group",
      boundary: ".form-group",
      animated: true,
      placement: "top",
      trigger: "manual",
      delay: { show: 100, hide: 100 },
    });
    log.success("Tooltips initialized");
  }

  initTooltips();
  initScrolling();


     const PRIMARY_COLOR = '#f17398';
    $('#petlocket').on('change', function() {
    if ($(this).is(':checked')) {
      $(this).closest('.purchase__pet-locket').css('border', `2px solid ${PRIMARY_COLOR}`);
    } else {
        $(this).closest('.purchase__pet-locket').css('border', "2px solid #F0F0F4");
    }
  });
});
